import styled from 'styled-components'
import { Text } from './Text'

export const Code = styled(Text).attrs({
  as: 'code',
  fontFamily: 'code',
})`
  display: inline-flex;
  border-radius: ${({ theme }) => theme.radii[0]};
  background-color: ${({ theme }) => theme.colors.textA[5]};
  border: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.code};
  font-weight: 300 !important;
  font-size: 80%;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
`

Code.defaultProps = {
  fontSize: 2,
  paddingX: 1,
  paddingY: 'small',
  color: 'primaryA.64',
}
